const massInputValidationMixin = {
  methods: {
    getMassInputErrors (massInput, params) {
      let minimumInvoices = 2
      if (!!params && !!params.minimumInvoices) {
        minimumInvoices = params.minimumInvoices
      }
      let tempArray = massInput.trim().replace(/(^[ \t]*\n)/gm, '').split(/\r?\n/).map(string => string.trim())
      let isDuplicate = []
      let currentLine = 1
      let errorList = []
      if (tempArray.length >= minimumInvoices) {
        Array.from(tempArray).forEach(row => {
          let temp = row.trim().match(/\S+/g)
          let hasWhitespace = /\s/g.test(row)
          let amount, invoiceId
          if (!hasWhitespace) {
            invoiceId = row
            amount = ''
          } else {
            amount = temp[1]
            invoiceId = temp[0]
          }
          if (invoiceId === '') {
            errorList.push(this.$t('groupSettlement.massInputError.malformedLine', [currentLine]))
          } else if (temp.length > 2) {
            errorList.push(this.$t('groupSettlement.massInputError.malformedLine', [currentLine]))
          } else if (typeof isDuplicate[invoiceId] !== 'undefined') {
            errorList.push(this.$t('groupSettlement.massInputError.duplicateInvoice', [currentLine]))
          } else if (amount !== '' && isNaN(amount) && amount !== 0) {
            errorList.push(this.$t('groupSettlement.massInputError.nonNumberAmount', [currentLine]))
          } else {
            isDuplicate[temp[0]] = true
          }
          currentLine++
        })
      } else {
        errorList.push(this.$t('groupSettlement.massInputError.emptyOrTooFew'))
      }
      return errorList
    },
    parseMassInput (massInput) {
      return Array.from(massInput.trim().replace(/(^[ \t]*\n)/gm, '').split(/\r?\n/)).map(string => string.trim())
    }
  }
}

export { massInputValidationMixin }



// WEBPACK FOOTER //
// ./src/components/home/group-settlement/validators/mixin.js